import CheckInput from './CheckInput';

export default CheckInput;
